// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const ThGhostIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'th-ghost'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M5.52316 20.2854C5.83558 19.8302 6.45849 19.7144 6.91378 20.0265C7.37957 20.3462 7.87726 20.6233 8.40011 20.8518C8.97101 21.1011 9.57355 21.2931 10.1989 21.4201C10.74 21.53 11.0889 22.0587 10.9792 22.5998C10.8692 23.1408 10.3416 23.4908 9.8005 23.381C9.0351 23.2256 8.29805 22.9901 7.59933 22.6848C6.95949 22.4052 6.35101 22.0665 5.78194 21.6759C5.32698 21.3633 5.21074 20.7405 5.52316 20.2854Z"
          fill="currentColor"
        />
        <path
          d="M17.0857 20.0265C17.5408 19.7142 18.1636 19.8303 18.4763 20.2854C18.7888 20.7407 18.6729 21.3635 18.2175 21.6759C17.6483 22.0665 17.0401 22.4052 16.4001 22.6848C15.7013 22.9901 14.9644 23.2256 14.1989 23.381C13.6579 23.4907 13.1291 23.1408 13.0192 22.5998C12.9097 22.0589 13.2597 21.5301 13.8005 21.4201C14.426 21.2931 15.0284 21.1011 15.5993 20.8518C16.1223 20.6232 16.6198 20.3463 17.0857 20.0265Z"
          fill="currentColor"
        />
        <path
          d="M2.00069 13.6203C2.54173 13.5104 3.06927 13.8607 3.1794 14.4015C3.30635 15.027 3.49835 15.6295 3.74776 16.2003C3.98001 16.7319 4.26314 17.2376 4.58956 17.7102C4.9032 18.1645 4.78894 18.7869 4.33468 19.1007C3.8804 19.4143 3.25796 19.3009 2.94405 18.8468C2.54532 18.2698 2.19993 17.6515 1.91573 17.0011C1.6105 16.3025 1.37483 15.5653 1.21944 14.7999C1.10987 14.259 1.45983 13.7304 2.00069 13.6203Z"
          fill="currentColor"
        />
        <path
          d="M11.9997 1.60077C18.0747 1.60078 22.9995 6.52579 22.9997 12.6008C22.9997 13.3527 22.9244 14.0888 22.78 14.7999C22.6246 15.5654 22.3891 16.3023 22.0837 17.0011C21.7995 17.6517 21.4543 18.2696 21.0554 18.8468C20.7415 19.301 20.119 19.4144 19.6648 19.1007C19.2108 18.7868 19.0964 18.1644 19.4099 17.7102C19.7365 17.2375 20.0194 16.7321 20.2516 16.2003C20.5011 15.6294 20.6931 15.0271 20.8201 14.4015C20.9379 13.8206 20.9997 13.2183 20.9997 12.6008C20.9996 7.63036 16.9702 3.60078 11.9997 3.60077C10.5859 3.60084 9.25016 3.92604 8.06222 4.50506L7.91573 4.56269C7.76513 4.6085 7.60438 4.618 7.44796 4.59002L3.24385 3.83905L4.00655 8.008C4.04525 8.21922 4.01548 8.43742 3.92062 8.63006C3.52104 9.44135 3.23984 10.3216 3.1003 11.2482C3.01811 11.7944 2.50875 12.1712 1.9626 12.0891C1.41691 12.0066 1.04082 11.4972 1.12276 10.9514C1.276 9.93332 1.56999 8.96062 1.98214 8.0539L1.01632 2.78046C0.95751 2.45822 1.05963 2.12688 1.29073 1.89472C1.52191 1.66254 1.85296 1.55895 2.17549 1.61639L7.48995 2.56658C8.86732 1.9466 10.3944 1.60084 11.9997 1.60077Z"
          fill="currentColor"
        />
        <path
          d="M15.7888 13.7688C16.1793 13.3783 16.8123 13.3782 17.2029 13.7688C17.5931 14.1593 17.5933 14.7923 17.2029 15.1827C16.4729 15.9127 15.4442 16.2257 14.4958 16.2258C13.5475 16.2258 12.5187 15.9127 11.7888 15.1827C11.3983 14.7923 11.3983 14.1593 11.7888 13.7688C12.1793 13.3783 12.8123 13.3782 13.2028 13.7688C13.4729 14.0387 13.9444 14.2257 14.4958 14.2257C15.0472 14.2257 15.5188 14.0387 15.7888 13.7688Z"
          fill="currentColor"
        />
        <path
          d="M17.7497 9.98358C18.4399 9.98446 18.9983 10.5444 18.9977 11.2346C18.9969 11.9247 18.437 12.4834 17.7467 12.4826C17.0566 12.4819 16.498 11.9218 16.4987 11.2316C16.4995 10.5415 17.0596 9.98291 17.7497 9.98358Z"
          fill="currentColor"
        />
        <path
          d="M11.2507 9.97577C11.9411 9.97644 12.5005 10.5364 12.4997 11.2267C12.499 11.9168 11.9389 12.4755 11.2487 12.4748C10.5587 12.4741 9.99911 11.9139 9.99971 11.2238C10.0006 10.5339 10.5611 9.97529 11.2507 9.97577Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
ThGhostIcon.displayName = 'ThGhostIcon'
export { ThGhostIcon }
